import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiBox, MiDetailPageHeader, MiList } from "@miplatform/components";
import { useRouter } from "@miplatform/hooks";
import { mdiChevronLeft } from "@mdi/js";
import { useManageContactRelationshipsViewModel } from "./useManageContactRelationshipsViewModel";

export function ManageContactRelationships() {
  const { classes } = useStyles();
  const { contactCategories, isLoading, loadData } =
    useManageContactRelationshipsViewModel();
  const router = useRouter();

  useEffect(() => {
    loadData();
  }, []);

  const sections = [
    {
      fieldset: [
        {
          label: "Object",
          field: "object",
          renderValue: ({ object }) =>
            object[0].toUpperCase() + object.slice(1),
        },
        {
          label: "Relationship In Use",
          field: "relationshipInUse",
          renderValue: ({ relationshipInUse }) => {
            return relationshipInUse ? "Yes" : "No";
          },
        },
      ],
    },
  ];
  return (
    <div className={classes.contentContainer}>
      <MiDetailPageHeader
        title="Contact Relationships"
        titleIcon={mdiChevronLeft}
        loading={isLoading}
      />
      <MiBox>
        <MiList
          viewType="card"
          cardProps={{
            sections,
            leftCardProps: { fieldset: [] },
            onClick: (item) => {
              router.navigate(
                `/settings/relationship-management/contact-relationships/${item.object}`
              );
            },
          }}
          data={contactCategories}
          loading={isLoading}
          hideListPagination
        />
      </MiBox>
    </div>
  );
}

const useStyles = makeStyles()(() => ({
  contentContainer: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
    flexDirection: "column",
    width: "100%",
  },
}));
